package app.nestbridge.feature.invitations.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
class InvitationQrScanScreen : Screen

data class InvitationQrScanState(
    val eventSink: (InvitationQrScanEvent) -> Unit,
) : CircuitUiState

sealed interface InvitationQrScanEvent {
    data object Cancel : InvitationQrScanEvent
    data object SimulateScan : InvitationQrScanEvent
}
